"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const invisible_1 = __importDefault(require("../invisible/invisible"));
const collection_item_style_1 = __importDefault(require("./collection.item.style"));
class CollectionItem extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, label, hideLabel, value, prefix, idle, borderless, action } = this.props;
            return (jsx_runtime_1.jsxs("dl", Object.assign({ className: classes.root, "data-is-borderless": borderless }, { children: [jsx_runtime_1.jsx("dt", Object.assign({ className: classes.label }, { children: jsx_runtime_1.jsx(invisible_1.default, Object.assign({ visible: !hideLabel }, { children: label }), void 0) }), void 0),
                    jsx_runtime_1.jsxs("dd", Object.assign({ className: classes.content }, { children: [jsx_runtime_1.jsxs("div", Object.assign({ className: classes.value, "data-is-idle": idle }, { children: [prefix && jsx_runtime_1.jsx("span", Object.assign({ className: classes.prefix }, { children: prefix }), void 0), value] }), void 0),
                            action && jsx_runtime_1.jsx("div", Object.assign({ className: classes.action }, { children: action }), void 0)] }), void 0)] }), void 0));
        };
    }
}
exports.CollectionItem = CollectionItem;
CollectionItem.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    label: prop_types_1.default.string.isRequired,
    hideLabel: prop_types_1.default.bool,
    value: prop_types_1.default.string.isRequired,
    prefix: prop_types_1.default.node,
    idle: prop_types_1.default.bool,
    borderless: prop_types_1.default.bool,
    action: prop_types_1.default.node
};
CollectionItem.defaultProps = {
    hideLabel: false,
    prefix: null,
    idle: false,
    borderless: false,
    action: null
};
exports.default = react_jss_1.default(collection_item_style_1.default)(CollectionItem);
//# sourceMappingURL=collection.item.js.map